import { render, staticRenderFns } from "./AppleSignIn.vue?vue&type=template&id=5893e5d8&scoped=true&"
import script from "./AppleSignIn.vue?vue&type=script&lang=js&"
export * from "./AppleSignIn.vue?vue&type=script&lang=js&"
import style0 from "./AppleSignIn.vue?vue&type=style&index=0&id=5893e5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5893e5d8",
  null
  
)

export default component.exports